"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ProjectsCard = void 0;

var _core = require("@material-ui/core");

var _styles = require("@material-ui/core/styles");

var _clsx = _interopRequireDefault(require("clsx"));

var _react = _interopRequireDefault(require("react"));

var _reactI18next = require("react-i18next");

var _StatCard = _interopRequireDefault(require("../StatCard"));

var _StatCardHeader = _interopRequireDefault(require("../StatCardHeader"));

var _components = require("../../../components");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      backgroundColor: theme.palette.primary.light
    },
    whiteBold: {
      color: theme.palette.common.white,
      fontWeight: 'bold'
    }
  };
});

var ProjectsCard = function ProjectsCard(_ref) {
  var _ref$completed = _ref.completed,
      completed = _ref$completed === void 0 ? 0 : _ref$completed,
      _ref$inProgress = _ref.inProgress,
      inProgress = _ref$inProgress === void 0 ? 0 : _ref$inProgress,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, ["completed", "inProgress", "className"]);

  var classes = useStyles();

  var _useTranslation = (0, _reactI18next.useTranslation)('common'),
      t = _useTranslation.t;

  return /*#__PURE__*/_react.default.createElement(_StatCard.default, _extends({}, props, {
    className: (0, _clsx.default)(classes.root, className)
  }), /*#__PURE__*/_react.default.createElement(_components.Flex, {
    center: true
  }, /*#__PURE__*/_react.default.createElement(_StatCardHeader.default, null, t('dashboard.projectsTitle'))), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    justify: "center"
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true
  }, /*#__PURE__*/_react.default.createElement(_core.Box, {
    m: 1
  }, /*#__PURE__*/_react.default.createElement(_components.Flex, {
    center: true,
    dir: "ttb"
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "h3",
    gutterBottom: true,
    className: classes.whiteBold
  }, Math.floor(completed)), /*#__PURE__*/_react.default.createElement(_core.Typography, {
    align: "center",
    variant: "h6",
    className: classes.whiteBold
  }, t('projects.statuses.completed'))))), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true
  }, /*#__PURE__*/_react.default.createElement(_core.Box, {
    m: 1
  }, /*#__PURE__*/_react.default.createElement(_components.Flex, {
    center: true,
    dir: "ttb"
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "h3",
    gutterBottom: true,
    className: classes.whiteBold
  }, Math.floor(inProgress)), /*#__PURE__*/_react.default.createElement(_core.Typography, {
    align: "center",
    variant: "h6",
    className: classes.whiteBold
  }, t('projects.statuses.inProgress')))))));
};

exports.ProjectsCard = ProjectsCard;
ProjectsCard.propTypes = {};
var _default = ProjectsCard;
exports.default = _default;